"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Contacts: () => Contacts
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneContacts");
  return hybrid;
}
function getPermissionStatus() {
  try {
    return native().getPermissionStatus();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function requestPermission() {
  return native().requestPermission().catch(import_nativeError.rethrowNativeError);
}
function pickContact() {
  return native().pickContact().then(function(contact) {
    return contact !== null && contact !== void 0 ? contact : void 0;
  }).catch(import_nativeError.rethrowNativeError);
}
function search(name) {
  var limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
  return native().search(name, limit).catch(import_nativeError.rethrowNativeError);
}
function create(input) {
  return native().create(input).catch(import_nativeError.rethrowNativeError);
}
function update(identifier, changes) {
  return native().update(identifier, changes).catch(import_nativeError.rethrowNativeError);
}
function deleteContact(identifier) {
  return native().remove(identifier).catch(import_nativeError.rethrowNativeError);
}
var Contacts = Object.freeze({
  getPermissionStatus,
  requestPermission,
  pickContact,
  search,
  create,
  update,
  delete: deleteContact
});
//# sourceMappingURL=index.native.js.map
